<template>
	<div class="list-title">
		<ul>
			<li v-for="(item, i) in listData" :key="i">
				<span :class="active==item.name?'active':''" @click="getActive" :data-name="item.name">{{item.name}}</span>
				<div class="d-line" v-if="i<(listData.length-1)">|</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'listTitle',
		props: {
			active: {
				default: '办公新姿势'
			},
			listData: {
				default: function() {
					return [{
							name: '办公新姿势'
						},
						{
							name: '出行更轻松'
						},
						{
							name: '生活更舒适'
						}
					];
				}
			}
		},
		data() {
			return {};
		},
		mounted() {
			let that = this;
			// console.log(that.listData);
		},
		methods: {
			getActive(e) {
				//发送给父组件 哪个被选中
				this.$emit("active", e.target.dataset.name);
			}
		}
	}
</script>

<style scoped="scoped">
	.list-title {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		 
		font-weight: 600;
		color: rgba(24, 24, 24, 1);
		background-color: #FFFFFF;
	}

	ul {
		width: 100%;
		list-style-type: none;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0;
		max-width: 1024px;
		margin-left: 50px;
		/* margin-top: 30px; */
	}

	li {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}

	.d-line {
		margin: 0 50px;
		opacity: 0.2;
	}

	.active {
		border-bottom: #00C785 2px solid;
	}

	li span {
		font-family: Alibaba-PuHuiTi-M;
		padding: 30px 0;
		border-bottom: 2px solid white;
	}
</style>
